import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchNotifications,
  markAllNotificationsAsRead,
  deleteNotification,
  deleteAllNotifications,
  bulkActionNotifications
} from '../../store/slices/notificationSlice';

/**
 * Custom hook for managing notifications in JetSetter profile
 */
export const useNotifications = (page = 1, limit = 10, readStatus = 'all') => {
  const dispatch = useDispatch();
  const { items: notifications, loading, error, pagination, unreadCount } = useSelector(
    (state) => state.notifications
  );

  // Fetch notifications on mount or when parameters change
  useEffect(() => {
    dispatch(fetchNotifications({ page, limit, readStatus }));
  }, [dispatch, page, limit, readStatus]);

  // Mark all as read
  const handleMarkAllAsRead = useCallback(() => {
    dispatch(markAllNotificationsAsRead());
  }, [dispatch]);

  // Delete single notification
  const handleDeleteNotification = useCallback((id) => {
    return dispatch(deleteNotification(id));
  }, [dispatch]);

  // Delete all notifications
  const handleDeleteAll = useCallback(() => {
    return dispatch(deleteAllNotifications());
  }, [dispatch]);

  // Bulk action (mark read or delete selected)
  const handleBulkAction = useCallback((action, notificationIds) => {
    return dispatch(bulkActionNotifications({ action, notificationIds }));
  }, [dispatch]);

  // Refresh notifications
  const refreshNotifications = useCallback((refreshPage = page) => {
    dispatch(fetchNotifications({ page: refreshPage, limit, readStatus }));
  }, [dispatch, page, limit, readStatus]);

  return {
    notifications,
    loading,
    error,
    pagination,
    unreadCount,
    handleMarkAllAsRead,
    handleDeleteNotification,
    handleDeleteAll,
    handleBulkAction,
    refreshNotifications
  };
};

export default useNotifications;
